var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 6.66667H1.25C0.560833 6.66667 0 6.10583 0 5.41667V1.25C0 0.560833 0.560833 0 1.25 0H7.91667C8.60583 0 9.16667 0.560833 9.16667 1.25V5.41667C9.16667 6.10583 8.60583 6.66667 7.91667 6.66667ZM1.25 0.833333C1.02083 0.833333 0.833333 1.02 0.833333 1.25V5.41667C0.833333 5.64667 1.02083 5.83333 1.25 5.83333H7.91667C8.14583 5.83333 8.33333 5.64667 8.33333 5.41667V1.25C8.33333 1.02 8.14583 0.833333 7.91667 0.833333H1.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 19.9999H1.25C0.560833 19.9999 0 19.4391 0 18.7499V9.58325C0 8.89409 0.560833 8.33325 1.25 8.33325H7.91667C8.60583 8.33325 9.16667 8.89409 9.16667 9.58325V18.7499C9.16667 19.4391 8.60583 19.9999 7.91667 19.9999ZM1.25 9.16659C1.02083 9.16659 0.833333 9.35325 0.833333 9.58325V18.7499C0.833333 18.9799 1.02083 19.1666 1.25 19.1666H7.91667C8.14583 19.1666 8.33333 18.9799 8.33333 18.7499V9.58325C8.33333 9.35325 8.14583 9.16659 7.91667 9.16659H1.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 19.9999H12.0833C11.3941 19.9999 10.8333 19.4391 10.8333 18.7499V14.5833C10.8333 13.8941 11.3941 13.3333 12.0833 13.3333H18.75C19.4391 13.3333 20 13.8941 20 14.5833V18.7499C20 19.4391 19.4391 19.9999 18.75 19.9999ZM12.0833 14.1666C11.8541 14.1666 11.6666 14.3533 11.6666 14.5833V18.7499C11.6666 18.9799 11.8541 19.1666 12.0833 19.1666H18.75C18.9791 19.1666 19.1666 18.9799 19.1666 18.7499V14.5833C19.1666 14.3533 18.9791 14.1666 18.75 14.1666H12.0833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.6667H12.0833C11.3941 11.6667 10.8333 11.1058 10.8333 10.4167V1.25C10.8333 0.560833 11.3941 0 12.0833 0H18.75C19.4391 0 20 0.560833 20 1.25V10.4167C20 11.1058 19.4391 11.6667 18.75 11.6667ZM12.0833 0.833333C11.8541 0.833333 11.6666 1.02 11.6666 1.25V10.4167C11.6666 10.6467 11.8541 10.8333 12.0833 10.8333H18.75C18.9791 10.8333 19.1666 10.6467 19.1666 10.4167V1.25C19.1666 1.02 18.9791 0.833333 18.75 0.833333H12.0833Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_5404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCourses);
export default __webpack_public_path__ + "static/media/allCourses.547ba4dcaba41ea8de1bdebca0e80213.svg";
export { ForwardRef as ReactComponent };